<template>
  <div id="member">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column">
              <h1 class="title has-text-white">MEMBER</h1>
            </div>
          </div>
          <div class="columns">
            <transition name="fade">
              <div class="column" v-if="show">
                <div class="card">
                  <div class="card-image">
                    <figure class="image is-square">
                      <img src="../../static/img/kazumi.jpg" alt="Placeholder image">
                    </figure>
                  </div>
                  <div class="card-content">
                    <div class="media">
                      <div class="media-left"></div>
                      <div class="media-content">
                        <p class="title is-4 has-text-black">KAZME EGAWA</p>
                        <p class="subtitle is-6">@f0otboy_v</p>
                        <p class="subtitle is-5">
                          surfer
                          <br>candidate of Ph.D.
                          <br>hardware&software engineer
                        </p>
                      </div>
                    </div>
                    <div class="content">
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <div class="column">
              <div class="card">
                <div class="card-image">
                  <figure class="image is-square">
                    <img src="../../static/img/kenta.jpg" alt="KENTA ISHIKAWA">
                  </figure>
                </div>
                <div class="card-content">
                  <div class="media">
                    <div class="media-left"></div>
                    <div class="media-content">
                      <p class="title is-4 has-text-black">KENTA ISHIKAWA</p>
                      <p class="subtitle is-6">@kenta_ishikawa</p>
                      <p class="subtitle is-5">
                        surfer
                        <br>candidate of the national Japan team
                      </p>
                    </div>
                  </div>
                  <div class="content">
                    <p></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card">
                <div class="card-image">
                  <figure class="image is-square">
                    <img src="../../static/img/masahide.jpg" alt="MASAHIDE CHIBA">
                  </figure>
                </div>
                <div class="card-content">
                  <div class="media">
                    <div class="media-left"></div>
                    <div class="media-content">
                      <p class="title is-4 has-text-black">MASAHIDE CHIBA</p>
                      <p class="subtitle is-6">@</p>
                      <p class="subtitle is-5">
                        surfer
                        <br>3d printing engineer
                      </p>
                    </div>
                  </div>
                  <div class="content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      show: true
    };
  }
};
</script>
<style lang="scss" scoped>
#member {
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  word-break: break-all;
  font-feature-settings: "palt";
  padding-top: 4rem;
  background: linear-gradient(#161a3c 75%, #015871);
}
.title {
  font-family: "Staatliches", cursive;
}

.strong {
  font-family: "Staatliches", cursive;
  font-weight: 700;
  font-size: 2rem;
  font-feature-settings: "palt";
  padding-bottom: 1rem;
}

.italic {
  font-weight: 700;
  font-style: italic;
  font-size: 1.2rem;
  font-feature-settings: "palt";
  padding-bottom: 1rem;
}

.card {
  min-height: 50vh;
  border-radius: 12px;
}
img {
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Member.vue